<template>
  <section class="vehicle-page-overview">
    <div class="vehicle-page-overview__container">
      <div v-if="1 === 0" class="vehicle-page-overview__image-wrap">
        <QImg :src="imageUrl" class="vehicle-page-overview__image" no-spinner />
      </div>
      <div class="vehicle-page-overview__content">
        <div class="vehicle-page-overview__title-wrap">
          <p class="vehicle-page-overview__eyebrow">{{ eyebrow }}</p>
          <h2 class="vehicle-page-overview__title">{{ title }}</h2>
        </div>
        <p class="vehicle-page-overview__body">{{ description }}</p>
        <div class="vehicle-page-overview__actions">
          <CalculatorButton
            label="Enquire now"
            color="primary"
            rounded
            iconDirection="right"
            hasChevronIcon
            @click="$emit('enquire-now')"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { QImg } from 'quasar';
import CalculatorButton from '../CalculatorButton.vue';

export default {
  name: 'VehiclePageOverview',
  components: {
    QImg,
    CalculatorButton
  },
  props: {
    /** Ratebook item; title/description/imageUrl derived from this with fallback to defaultOverview */
    item: {
      type: Object,
      default: null
    },
    defaultOverview: {
      type: Object,
      default: () => ({
        label: 'OVERVIEW',
        title: '',
        description: '',
        imageUrl: ''
      })
    }
  },
  computed: {
    eyebrow() {
      return this.defaultOverview?.label ?? 'OVERVIEW';
    },
    title() {
      const i = this.item;
      const def = this.defaultOverview?.title ?? '';
      if (!i) return def;
      const fromItem = i.marketingSubject;

      return fromItem || def;
    },
    description() {
      const i = this.item;
      const def = this.defaultOverview?.description ?? '';
      if (!i) return def;
      const fromItem = i.marketingBodyText;

      return fromItem || def;
    },
    imageUrl() {
      const i = this.item;
      const def = this.defaultOverview?.imageUrl ?? '';
      if (!i) return def;
      const fromItem = i.overviewImageUrl;
      return fromItem || def;
    }
  }
};
</script>
